import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { axiosInstance } from '@/lib/axios'
import type { GroupModel } from '@/app/models/groupModel'

type Props = {
  companyId: string | undefined
  enabled?: boolean
}

/**
 * Fetches a company's driver groups. Replaces the imperative
 *   `getDriverGroups({ companyId })` + useState + useEffect pattern that
 * used to live inside DriversContext. Cached for 10 minutes — group
 * definitions change rarely compared to driver list contents.
 */
export function useQueryDriverGroups({ companyId, enabled = true }: Props) {
  return useQuery<GroupModel[]>({
    queryKey: ['driverGroups', String(companyId ?? '')],
    enabled: enabled && !!companyId,
    staleTime: MINUTE_IN_MS * 10,
    queryFn: async () => {
      const res = await axiosInstance.get(`/api/${companyId}/driver/groups`)
      return res.data ?? []
    },
  })
}
